import React from "react";
import "./coopModel.css";
import ModelImg1 from "../../../Assets/Images/Co-op_Model/Solo Developer_Lighter image.png";
import ModelImg2 from "../../../Assets/Images/Co-op_Model/Development-Team-icon.png";
import { Link } from "react-router-dom";

const CooperationMode = () => {
  return (
    <div id="hiring-model" className="coopertation-model-section">
      <div className="container">
        <div className="row">
          {/* Left-side */}
          <div className="col-lg-6">
            <h1 className="co-op-title">
              A Hiring Model That Fits How You Actually Build
            </h1>
            <p className="co-op-text">
              Some projects require one sharp mind. Others require a small and
              focused team moving together. Our hiring model is a flexible one
              by design, so you can start lean, scale with confidence and adjust
              without rethinking everything from scratch.
            </p>

            <p className="co-op-text">
              Contact us today to hire dedicated software experts who can help
              bring your projects to life.
            </p>
          </div>

          <div className="col-lg-6">
            <div className="card customised-co-op mb-5">
              <div className="card-body">
                <img
                  src={ModelImg1}
                  alt="solo_developer"
                  width={45}
                  height={50}
                />
                <h5 className="card-titles">Solo Developer </h5>
                <p className="card-text mb-4">
                  Best if you need to execute something with focus, make quick
                  fixes, or own a particular feature without adding extra layers
                  of management.
                </p>
                <Link to="/contact-us/hiring-team">
                  <button className="btn hire-btn">Hire A Developer</button>
                </Link>
              </div>
            </div>

            <div className="card customised-co-op">
              <div className="card-body">
                <img
                  src={ModelImg2}
                  alt="team_developers"
                  width={55}
                  height={50}
                />
                <h5 className="card-titles">Dedicated Team </h5>
                <p className="card-text mb-4">
                  Ideal for growing products that require collaboration, shared
                  context and consistent momentum across features, releases, and
                  long-term roadmap.
                </p>
                <Link to="/contact-us/hiring-team">
                  <button className="btn hire-btn">
                    Build A Dedicated Team
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CooperationMode;
